module.exports = __webpack_public_path__ + "img/medical_medicine_etc.55330347.jpg";